export const styles = {
    panelStyles: {
        root: {
            boxShadow: 'none',
            borderRadius: 0,
            overflow: 'hidden',
            '&:before': {
                display: 'none',
            },
            '&$expanded': {
                margin: 'auto',
                borderRadius: 0,
            },
            '&:first-child': {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
            },
            '&:last-child': {
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
            },
            '&:first-child$expanded': {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
            },
            '&:last-child$expanded': {
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
            },
            '@media (hover: hover)': {
                '&:hover': {
                    backgroundColor: '#FFEAE7',
                },
                '&$expanded:hover': {
                    backgroundColor: '#FFEAE7',
                },
            },
        },
        expanded: {},
    },
    summaryStyles: {
        root: {
            position: 'relative',
            minHeight: 45,
            margin: '-1px 0 0',
            '&$expanded': {
                minHeight: 45,
                backgroundColor: 'rgba(247,249,252,1)',
            },
            '@media (hover: hover)': {
                '&:hover': {
                    backgroundColor: '#FFEAE7',
                },
                '&$expanded:hover': {
                    backgroundColor: '#FFEAE7',
                },
            },
            '& h3': {
                font: '400 16px/20px "InterDisplay", sans-serif',
                margin: 'inherit',
                color: '#27272A',
                padding: '0 16px',
            },
            padding: '0 0px 0 0px',
            color: 'rgb(90, 144, 220)'
        },
        content: {
            lineHeight: 0,
            margin: '6px 0',
            '&$expanded': {
                margin: '6px 0',
            },
        },
        expandIcon: {
            top: '23px',
            right: '12px',
            size: '8px',
            color: '#27272A',
            padding: 0,
            '& svg': {
                fontSize: '20px'
            }
        },
        expanded: {},
    }
};

export const pritnableViewStyles = {
    panelStyles: {
        root: {
            boxShadow: 'none',
            borderRadius: 0,
            overflow: 'hidden',
            '&:before': {
                display: 'none',
            },
            '&$expanded': {
                margin: 'auto',
                borderRadius: 0,
            },
            '&:first-child': {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
            },
            '&:last-child': {
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
            },
            '&:first-child$expanded': {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
            },
            '&:last-child$expanded': {
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
            },
            '@media (hover: hover)': {
                '&:hover': {
                    backgroundColor: '#FFEAE7',
                },
                '&$expanded:hover': {
                    backgroundColor: '#FFEAE7',
                },
            },
        },
        expanded: {},
    },
    summaryStyles: {
        root: {
            position: 'relative',
            minHeight: 45,
            margin: '-1px 0 0',
            '&$expanded': {
                minHeight: 45,
            },
            '@media (hover: hover)': {
                '&:hover': {
                    backgroundColor: '#FFEAE7',
                },
                '&$expanded:hover': {
                    backgroundColor: '#FFEAE7',
                },
            },
            '& h3': {
                font: '500 16px/20px "InterDisplay", sans-serif',
                margin: 0,
                padding: '0 16px',
            },
            padding: '0 0px 0 0px',
        },
        content: {
            lineHeight: 0,
            margin: '5px 0',
            '&$expanded': {
                margin: '5px 0',
            },
        },
        expandIcon: {
            visibility: 'hidden',
            top: '23px',
            right: '12px',
            size: '8px',
            padding: 0,
            '& svg': {
                fontSize: '20px'
            }
        },
        expanded: {},
    }
};
